import "./styles.scss";

import React from "react";

import { useMainGlobal } from "context/main-global";

import Heading from "components/Heading";
import OpinionCard from "components/OpinionCard";
import CardSlider from "components/CardSlider";

import { getColorVariant } from "utils";

const Opinions = () => {
  const { opinionsData } = useMainGlobal();

  return (
    opinionsData?.length > 0 && (
      <section className="main-opinions">
        <div className="container">
          <Heading title="Opinie" />
          <div className="row d-none d-sm-flex">
            {opinionsData.map((item, index) => (
              <div key={index} className="col-xl-3 col-sm-6">
                <OpinionCard
                  url={item.content.link}
                  logo={item.logo?.sourceUrl}
                  rating={{
                    average: item.content.average,
                    amount: item.content.amount,
                  }}
                  location={item.content.location}
                  variant={getColorVariant(index + 1)}
                />
              </div>
            ))}
          </div>
          <CardSlider breakpoint="sm">
            {opinionsData.map((item, index) => (
              <div key={index}>
                <OpinionCard
                  url={item.content.link}
                  logo={item.logo?.sourceUrl}
                  rating={{
                    average: item.content.average,
                    amount: item.content.amount,
                  }}
                  location={item.content.location}
                  variant={getColorVariant(index + 1)}
                />
              </div>
            ))}
          </CardSlider>
        </div>
      </section>
    )
  );
};

export default Opinions;
